import { createContext, useContext } from "react";

export const GuideCtx = createContext(null);

export function useGuide() {
  return useContext(GuideCtx) || { isCoach: false };
}
